module.exports = __webpack_public_path__ + "static/media/linkedin.bd307493.svg";